import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import zIndexes from "zIndexes.module.scss";

export const useStyles = makeStyles((theme) => ({
  popover: {
    zIndex: zIndexes.notificationsZIndex,
  },
  card: {
    padding: "10px 20px",
    boxShadow: "2px 4px 20px rgba(0, 0, 0, 0.1)",
    maxWidth: 400,
    borderRadius: 10,
  },
  cardContent: {
    paddingTop: 12,
  },
  infoIcon: {
    height: 20,
    width: 20,
    marginRight: 10,
    color: theme.palette.yellow.dark,
  },
  title: {
    color: theme.palette.blue.dark,
    lineHeight: "22px",
  },
  description: {
    marginTop: 12,
    marginBottom: 20,
    lineHeight: "19px",
    color: theme.palette.blue.darkShade1,
  },
  buttons: {
    marginLeft: 10,
    padding: 0,
  },
  buttonContent: {
    padding: "0 15px",
  },
}));
